import { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { getCategory } from '../../lib/utils/apiCalls';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategoryCollections, setModal } from '../../Features/collectionsSlice';
import ArrowLeft from '../../Assets/Arrow left.svg';
import Minus from "../../Assets/MinusCheckbox.svg";
import TickMark from '../../Assets/Modals/TickMark.svg';
import CollectionBar from './CollectionBar';
import PlusIcon from "../../Assets/PlusIcon/Add.svg";
import { CategoryCollectionContext } from '../../Context/Collections/CategoryCollectionContext';
import Modal from './Modal/Modal';
import Loading from '../../Components/Loading/Loading';
import Error from '../../Components/Error/Error';

function Category() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    const [category, setCategory] = useState({});

    const { selectedCategoryCollections, setSelectedCategoryCollections } = useContext(CategoryCollectionContext);

    const { categoryCollections: collections, loading } = useSelector((state) => state.collections.categoryCollections);

    const [checkboxType, setCheckboxType] = useState('');

    const handleCheckboxClick = () => {
        if(selectedCategoryCollections.length < collections.length) {
            if(selectedCategoryCollections.length === 0) {
                let listId = collections.map(item => item.id);
                setSelectedCategoryCollections(listId);
            }
            else {
                setSelectedCategoryCollections([]);
            }
        }
        else {
            setSelectedCategoryCollections([]);
        }
    }

    useEffect(() => {
        const fetchCategoryData = async () => {
            try {
                const response = await getCategory(params.categoryId);
                if(response?.status === 200) {
                    setCategory(response.data.data.category);
                }
            } catch(err) {
                console.log(err);
            }
        }

        if (params.categoryId) {
            dispatch(fetchCategoryCollections(params.categoryId));
            fetchCategoryData();
        }
        // eslint-disable-next-line
    }, [params.categoryId]);

    useEffect(() => {
        if(selectedCategoryCollections.length < collections?.length) {
            if(selectedCategoryCollections?.length === 0) {
                setCheckboxType('');
            }
            else {
                setCheckboxType('half')
            }
        }
        else if(selectedCategoryCollections?.length === 0) {
            setCheckboxType('');
        }
        else {
            setCheckboxType('full');
        }
    }, [selectedCategoryCollections, collections]);

    const handleAddCollection = () => {
        navigate(`${location.pathname}/collection/add-collection`);
    }

    const handleDeleteList = () => {
        dispatch(setModal('delete-confirm'));
    }

    const handleHideList = () => {
        dispatch(setModal('hide-confirm'));
    }

    if(loading === 'loading') {
        return <Loading />
    }

    if(loading === 'failed') {
        return <Error />
    }

    return (
        <div className="size-full overflow-y-scroll pb-16 outline-none">
            <div className="select-none flex items-center gap-2 relative m-[20px_19px_24px_20px]">
                <Link to='..' className="p-[10px] flex items-center justify-center">
                    <img className='size-6 text-[#666666]' src={ArrowLeft} alt="" />
                </Link>

                <h1 className="p-[6px] text-[#121212] font-bold text-2xl">{category.categoryName} Category</h1>
            </div>

            {
                collections.length !== 0 && 
                <div className="mx-5">
                    <button onClick={handleAddCollection} className='outline-none flex items-center gap-[2px] p-[8px_16px_8px_10px] bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText rounded ml-auto'>
                        <div className="size-6 flex items-center justify-center">
                            <img src={PlusIcon} alt="" />
                        </div>

                        Add Collection
                    </button>
                </div>
            }

            <div className="flex flex-col mt-6 mx-5">
                <div className="flex bg-[#F5F5F5] font-semibold text-[#121212] text-[16px] leading-8">
                    <div className="flex items-center gap-2 w-[calc((54/100)*(100%-44px))] px-[10px] py-[8px]">
                        {
                            collections.length > 0 &&
                            <div onClick={handleCheckboxClick} className={`cursor-pointer size-6 bg-[#FFFFFF] flex items-center justify-center rounded-md border ${checkboxType !== '' ? 'border-none bg-primaryAccent' : 'border-[#D1D5DB]'} `} >
                                <img className='select-none' src={checkboxType === 'full' ? TickMark : checkboxType === '' ? undefined : Minus} alt="" />
                            </div>
                        }

                        <h2 className="">Collection name</h2>
                    </div>

                    <h2 className="w-[calc((18/100)*(100%-44px))] px-[10px] py-[8px]">Total Product(s)</h2>
                    <h2 className="w-[calc((18/100)*(100%-44px))] px-[10px] py-[8px]">Duration</h2>
                    <h2 className="w-[calc((10/100)*(100%-44px))] px-[10px] py-[8px]">Mark Active</h2>
                    <div className="w-[44px]"></div>
                </div>

                {[ ...collections ]?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map(collection => {
                    const isSelected = selectedCategoryCollections.includes(collection.id);
                    let duration;
                    if(collection.startDuration && collection.endDuration) {
                        const futureDate = new Date(collection.endDuration);
                        const currentDate = new Date();
                        const differenceInMillis = futureDate - currentDate;
                        duration = Math.floor(differenceInMillis / (1000 * 60 * 60 * 24));
                    }

                    return (
                        <CollectionBar 
                            key={collection.id} 
                            collection={collection} 
                            isSelected={isSelected} 
                            duration={duration} 
                        />
                    )
                })}

                {
                    collections.length === 0 && 
                    <div className="mx-auto mt-20 flex flex-col items-center gap-6 w-3/5">
                        <div className="flex flex-col gap-2 text-[#666666] items-center">
                            <h1 className='font-semibold text-[18px] leading-7'>Start Your Collection</h1>

                            <p className='text-center font-medium text-[16px] leading-7'>You’re all set to organize your products into collections. Collections help buyers find what they're looking for. Let’s create your first collection within this category.</p>
                        </div>

                        <button onClick={handleAddCollection} className='outline-none flex items-center gap-[2px] p-[8px_16px_8px_10px] bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText rounded'>
                            <div className="size-6 flex items-center justify-center">
                                <img src={PlusIcon} alt="" />
                            </div>

                            Add Collection
                        </button>
                    </div>
                }
            </div>

            {
                selectedCategoryCollections.length > 0 && 
                <div className="fixed left-1/2 -translate-x-1/2 bottom-12 border border-[#EAEAEA] bg-[#F5F5F5] rounded-xl p-4 flex items-center gap-3">
                    <p className='font-medium text-[14px] leading-5 text-[#121212]'>{selectedCategoryCollections.length}/{collections.length}</p>

                    <button onClick={handleDeleteList} className='px-4 py-2 rounded bg-[#FFFFFF] font-semibold text-base text-[#808080] outline-none select-none'>Delete</button>

                    <button onClick={handleHideList} className='px-4 py-2 rounded bg-[#FFFFFF] font-semibold text-base text-[#808080] outline-none select-none'>Hide</button>
                </div>
            }

            <Modal />
        </div>
    );
}

export default Category;
